import React, { useEffect, useState } from "react";
import "./WeatherForecast.css";
import axios from "axios";
import { formatedDate } from "./utils/formattedDate";

function WeatherForecast({ city }) {
  const [loading, setLoading] = useState(true);
  const [forecastData, setForecastData] = useState({});
  useEffect(() => {
    function handleResponce(responce) {
      setForecastData(responce.data.daily);
      setLoading(false);
    }
    function search() {
      let url = `https://api.shecodes.io/weather/v1/forecast?query=${city}&key=cbofbec7cf9d3c845e0da48b7238784t&units=metric`;
      axios.get(url).then(handleResponce);
    }
    search();
  }, [city]);
  function stringTime(time) {
    const { day, hours, minutes } = formatedDate(time);
    return (
      <b>
        {day} <br />
        {hours}:{minutes}
      </b>
    );
  }

  if (loading) {
    return "Loading...";
  }
  return (
    <div className="WeatherForecast">
      <div className="row">
        {forecastData.slice(0, -2).map((el) => (
          <div className="col">
            <div className="day">{stringTime(el.time)}</div>
            <img src={el.condition.icon_url} alt={el.condition.description} />
            <div className="temperatures">
              <span className="temperature-max">19°</span>
              <span className="temperature-min">10°</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WeatherForecast;
